import { athleteEligibilityResponseSchema, eligibilityResponseSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export const eligibility = {
	calculate: (birthYear: number, season?: number) => {
		const query = new URLSearchParams({ birthYear: String(birthYear) });
		if (season) query.set("season", String(season));
		return fetchApi(`/eligibility?${query}`, eligibilityResponseSchema);
	},
	forAthlete: (athleteId: string, season?: number) => {
		const query = season ? `?season=${season}` : "";
		return fetchApi(`/athletes/${athleteId}/eligibility${query}`, athleteEligibilityResponseSchema);
	},
};
